<template>
    <v-app>
        <div id="app">
            <Widget />
        </div>
    </v-app>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {};
        },
        components: {
            Widget: () => import('./components/Widget.vue'),
        },
    };
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        font-size: 14px;
        background-color: transparent;
        overflow-x: hidden;
        overflow-y: hidden;
        height: 100%;
    }
    body,
    html {
        overflow-x: hidden;
        overflow-y: hidden;
    }

    html {
        --scrollbarBG: #cfcfcf;
        --thumbBG: #7b7b7b;
    }
    div ::-webkit-scrollbar {
        width: 5px;
    }
    div {
        scrollbar-width: thin;
        scrollbar-color: var(--thumbBG) var(--scrollbarBG);
    }
    div ::-webkit-scrollbar-track {
        background: transparent;
        margin-bottom: 10px;
        margin-top: 10px;
        background-color: #eee;
        border-radius: 5px;
    }
    div ::-webkit-scrollbar-thumb {
        background-color: #ddd !important;
        border-radius: 6px;
        border: 3px solid var(--scrollbarBG);
    }
</style>
